import React from 'react';
import { Button } from 'semantic-ui-react';
import { Modal } from 'dyl-components';

import IntegrateForm from 'shared/forms/IntegrateForm';

const IntegrateModal = ({ open, onClose }) => (
    <Modal open={open} onClose={onClose}>
        <Modal.Header>
            Add Prospect
        </Modal.Header>
        <Modal.Content>
            <IntegrateForm />
        </Modal.Content>
        <Modal.Actions>
            <Button basic onClick={onClose}>Cancel</Button>
            <Button primary>Integrate</Button>
        </Modal.Actions>
    </Modal>
)

export default IntegrateModal;
